import { RepositoryFactory } from '@/legacy/repositories/RepositoryFactory'
const AdvertiserRepository = RepositoryFactory.get('advertiser')

export default {
  namespaced: true,
  state: {
    googleAnalytics: {
      loading: false,
      gaProperties: [],
      gaSelectedProperty: null,
      isActive: false,
    },
    jsPixel: {
      loading: false,
      config: null,
      isActive: false,
    },
  },
  getters: {
    gaLoading: (state) => state.googleAnalytics.loading,
    gaProperties: (state) => state.googleAnalytics.gaProperties,
    gaSelectedProperty: (state) => state.googleAnalytics.gaSelectedProperty,
    gaIsActive: (state) => state.googleAnalytics.isActive,
    jpIsActive: (state) => state.jsPixel.isActive,
  },
  mutations: {
    UPDATE_GA_ATTRIBUTE: (state, { type, value }) => (state.googleAnalytics[type] = value),
    UPDATE_JP_ATTRIBUTE: (state, { type, value }) => (state.jsPixel[type] = value),
  },
  actions: {
    getOrderCollectors: async ({ rootState, commit }) => {
      commit('UPDATE_GA_ATTRIBUTE', {
        type: 'loading',
        value: true,
      })
      commit('UPDATE_JP_ATTRIBUTE', {
        type: 'loading',
        value: true,
      })
      try {
        const { data } = await AdvertiserRepository.getAllTrackingConfigs(
          rootState.user.token,
          rootState.shop.shop.id,
        )

        const selectedGaProperty =
          data.ga_configs?.properties?.find((item) => item.selected)?.id || null

        // update ga attributes
        commit('UPDATE_GA_ATTRIBUTE', {
          type: 'gaProperties',
          value: data.ga_configs?.properties,
        })
        commit('UPDATE_GA_ATTRIBUTE', {
          type: 'gaSelectedProperty',
          value: selectedGaProperty,
        })
        commit('UPDATE_GA_ATTRIBUTE', {
          type: 'isActive',
          value: data.ga_configs?.is_active,
        })

        // update jp attributes
        commit('UPDATE_JP_ATTRIBUTE', {
          type: 'config',
          value: data.td_configs?.configs,
        })
        commit('UPDATE_JP_ATTRIBUTE', {
          type: 'isActive',
          value: data.td_configs?.is_active,
        })
      } catch {
        // swallow
      } finally {
        commit('UPDATE_GA_ATTRIBUTE', {
          type: 'loading',
          value: false,
        })
        commit('UPDATE_JP_ATTRIBUTE', {
          type: 'loading',
          value: false,
        })
      }
    },
    connectGoogleAnalytics: async ({ rootState, commit }, code) => {
      try {
        commit('UPDATE_GA_ATTRIBUTE', {
          type: 'loading',
          value: true,
        })
        const { data } = await AdvertiserRepository.connectStoreWithGoogleAnalytics(
          rootState.user.token,
          code,
          rootState.shop.shop.id,
        )
        return data
      } catch (error) {
        commit('UPDATE_GA_ATTRIBUTE', {
          type: 'googleAnalyticsRes',
          value: error,
        })
      } finally {
        commit('UPDATE_GA_ATTRIBUTE', {
          type: 'loading',
          value: false,
        })
      }
    },
    async updateSelectedGaProperty({ commit, state, rootState }) {
      try {
        commit('UPDATE_GA_ATTRIBUTE', {
          type: 'loading',
          value: true,
        })

        const gaSelectedPropertyId = state.googleAnalytics.gaSelectedProperty

        const { data } = await AdvertiserRepository.updateSelectedGaProperty(
          rootState.user.token,
          rootState.shop.shop.id,
          gaSelectedPropertyId,
        )
        return data
      } catch (error) {
        commit('UPDATE_GA_ATTRIBUTE', {
          type: 'googleAnalyticsRes',
          value: error,
        })
      } finally {
        commit('UPDATE_GA_ATTRIBUTE', {
          type: 'loading',
          value: false,
        })
      }
    },
  },
}
